export default "__VITE_ASSET__308dcf8a__"